export const ReferralPageEvent = {
  ReferralPageView: 'referral_page_view',
  ReferralPageBannerClick: 'referral_page_banner_click',
  ReferralPageBenefitClick: 'referral_page_referral_benefit_click',
  ReferralPageShareVipClick: 'referral_page_share_vip_click',
  ReferralPageViewMyReferralClick: 'referral_page_view_my_referral_click',
  ReferralViewExampleClick: 'referral_view_example_click',
  ReferralLearnMoreClick: 'referral_learn_more_click',
  ReferralCopyClick: 'referral_copy_click',
  ReferralShareClick: 'referral_share_click',
  ReferralDashboardView: 'referral_dashboard_page',
  ReferralDashboardReferralTabClick: 'referral_tab_click',
  ReferralDashboardClickCopyLink: 'referral_dashboard_page__click_copy_link',
  ReferralDashboardClickCopyCode: 'referral_dashboard_page__click_copy_code',
  ReferralDashboardClickChangeRewardsHistoryRange: 'referral_dashboard_page__click_change_rewards_history_range',
  ReferralDashboardClickChangeReferralHistoryRange: 'referral_dashboard_page__click_change_referral_history_range',
  ReferralPageLandingBannerView: 'referral_page_landing_banner_view',
  ReferralPageLandingBannerClick: 'referral_page_landing_banner_click',
} as const;

export interface ReferralPageEventDataType {
  [ReferralPageEvent.ReferralViewExampleClick]: {
    list_order: number;
  };
  [ReferralPageEvent.ReferralLearnMoreClick]: {
    refer_type: 'referrer' | 'referee';
  };
  [ReferralPageEvent.ReferralDashboardReferralTabClick]: {
    tab_type: string;
  };
  [ReferralPageEvent.ReferralDashboardClickChangeReferralHistoryRange]: {
    start_date: string;
    end_date: string;
  };
  [ReferralPageEvent.ReferralPageLandingBannerView]: {
    event_type: string;
  };
  [ReferralPageEvent.ReferralPageLandingBannerClick]: {
    event_type: string;
  };
  [ReferralPageEvent.ReferralPageView]: {
    reward_amount?: number;
  };
  [ReferralPageEvent.ReferralPageBannerClick]: {
    reward_amount?: number;
    banner_text: string;
  };
}
